/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForMetricValueStorage extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForMetricValueStorage");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForMetricValueStorage.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForMetricValueStorage>): BackgroundJobPayloadForMetricValueStorage {
        let obj = Object.assign(new BackgroundJobPayloadForMetricValueStorage(), model);
        BackgroundJobPayloadForMetricValueStorage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForMetricValueStorage>): BackgroundJobPayloadForMetricValueStorage {
        if (!model) return null;
        return BackgroundJobPayloadForMetricValueStorage.newInstance(<BackgroundJobPayloadForMetricValueStorage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForMetricValueStorage) {
        if (!obj) return;

        models.BackgroundJobPayloadForMetricValueStorage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForMetricValueStorage): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForMetricValueStorage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    is_custom: boolean;

}
